<div class="container">
    <h2 class="text-center">Apply Now</h2>
        <hr>
    <div class="row">
        <form #contactForm="ngForm" (ngSubmit)="submit(contactForm)">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="form-name">Your Name</label>
                    <input type="text" #name="ngModel"  name="name" [ngModel]="user.name" id="form-name" class="form-control" placeholder="Your Name" required>
                    <div *ngIf="name.dirty" >
                        <div *ngIf="name.errors">
                            <div *ngIf="name.errors.required"  style="color: red;">
                                This field required.
                            </div>

                         </div>
                    </div>
                </div>
                <div class="form-group col-md-6">
                    <label for="form-phone-number">Phone Number</label>
                    <input type="text" minlength="10" maxlength="10"
                    pattern="^[0-9]*$"
                    #phone_no="ngModel" name="phone_no" [ngModel]="user.phone_no" id="form-phone-number" class="form-control" required placeholder="Your Phone Number">
                    <div *ngIf="phone_no.dirty" >
                        <div *ngIf="phone_no.errors">
                            <div *ngIf="phone_no.errors.required"  style="color: red;">
                                This field required.
                            </div>

                            <div *ngIf="phone_no.errors.pattern" style="color: red;">
                               Only Numbers allowed.
                            </div>
                            <div *ngIf="phone_no.errors.minlength"  style="color: red;">
                                Invalid Number
                              </div>

                         </div>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <label for="form-email">Email</label>
                <input type="email"
                required [pattern]="emailPattern"
                #email="ngModel" name="email" [ngModel]="user.email" id="form-email" class="form-control" placeholder="Email Address">
                <div *ngIf="email.dirty" >
                    <div *ngIf="email.errors">
                        <div *ngIf="email.errors.required"  style="color: red;">
                            This field required.
                        </div>
                        <div *ngIf="email.errors.pattern"  style="color: red;">
                            Please enter a valid Email.
                        </div>
                     </div>
                </div>

            </div>
            <div class="form-group">
                <label for="form-subject">Subject</label>
                <input type="text" #subject="ngModel" name="subject" [ngModel]="user.subject" id="form-subject" class="form-control" required placeholder="Subject">
                <div *ngIf="subject.dirty" >
                    <div *ngIf="subject.errors">
                        <div *ngIf="subject.errors.required"  style="color: red;">
                            This field required.
                        </div>

                     </div>
                </div>
            </div>
            <div class="form-group">
                <label for="form-message">Message</label>
                <textarea id="form-message" #message="ngModel" name="message" [ngModel]="user.message" required class="form-control" rows="4"></textarea>
                <div *ngIf="message.dirty" >
                    <div *ngIf="message.errors">
                        <div *ngIf="message.errors.required"  style="color: red;">
                            This field required.
                        </div>

                     </div>
                </div>
            </div>
            <button type="submit" [disabled]="contactForm.invalid" class="btn btn-primary">Send Message</button>
        </form>
    </div>
</div>